import React from 'react';
import './Page.css';

const ContactUs = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Contact Us</h1>
      </div>
      <div className="page-content">
        <div className="contact-layout">
          <div className="contact-map">
            <iframe
              title="Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3643.1240516105204!2d78.08112467544213!3d24.061935678459104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3979678bd2b7e55b%3A0x216132c20b2b6013!2sMillennium%20Model%20School!5e0!3m2!1sen!2sin!4v1691687388183!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="contact-info-panel">
            <h2>MILLENNIUM MODEL SCHOOL</h2>
            <div className="contact-details">
              <div className="contact-detail-item">
                <strong>Office Hours:</strong>
                <p>11:30 AM - 3:00 PM</p>
              </div>
              <div className="contact-detail-item">
                <strong>Address:</strong>
                <p>Khajrod Road, Mandi Bamora, Sagar District, Madhya Pradesh - 464240</p>
              </div>
              <div className="contact-detail-item">
                <strong>Phone Number:</strong>
                <p>
                  <a href="tel:+918770719148">+91-8770719148</a><br />
                  <a href="tel:+918982352628">+91-8982352628</a>
                </p>
              </div>
              <div className="contact-detail-item">
                <strong>Email:</strong>
                <p>
                  <a href="mailto:millenniummodel2000@gmail.com">
                    millenniummodel2000@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;

